import moment from 'moment';

// Define a custom TranslationFunction type
export type TranslationFunction = (
  key: string | string[],
  options?: Record<string, any>
) => string;

export const generateFrequencyMessage = (
  frequencyValue: string,
  startDate: Date,
  stopEventDate: Date | null,
  weekNumberInMonth: number | null,
  t: TranslationFunction
): string | null => {
  // Format stopEventDate as 'Month Day, Year'
  const formattedStopDate = moment(stopEventDate).format('MMMM DD, YYYY');

  // Generate the message based on the frequency value
  switch (frequencyValue) {
    case 'never':
      return t('messaging:never');

    case 'daily':
      if (stopEventDate === null) {
        return t('groups:frequency_daily');
      } else {
        return t('groups:frequency_daily_until', {
          stopDate: formattedStopDate,
        });
      }

    case 'weekly':
      if (stopEventDate === null) {
        return t('groups:frequency_every_interval_week_on_selected_day_one', {
          count: 2,
          weekday: moment(startDate).format('dddd'),
        });
      } else {
        return t(
          'groups:frequency_every_interval_week_on_selected_day_one_until',
          {
            count: 2,
            weekday: moment(startDate).format('dddd'),
            stopDate: formattedStopDate,
          }
        );
      }

    case 'every_interval_week_on':
      if (stopEventDate === null) {
        return t('groups:frequency_every_interval_week_on_selected_day_other', {
          count: 2,
          weekday: moment(startDate).format('dddd'),
        });
      } else {
        return t(
          'groups:frequency_every_interval_week_on_selected_day_other_until',
          {
            count: 2,
            weekday: moment(startDate).format('dddd'),
            stopDate: formattedStopDate,
          }
        );
      }

    case 'monthly_on_selected_day':
      if (stopEventDate === null) {
        return t('groups:frequency_monthly_on', {
          weekNumberOrdinal: t('common:key', {
            count: weekNumberInMonth,
            ordinal: true,
          }),
          weekday: moment(startDate).format('dddd'),
        });
      } else {
        return t('groups:frequency_monthly_on_until', {
          weekNumberOrdinal: t('common:key', {
            count: weekNumberInMonth,
            ordinal: true,
          }),
          weekday: moment(startDate).format('dddd'),
          stopDate: formattedStopDate,
        });
      }

    case 'annually_on_month_day':
      if (stopEventDate === null) {
        return t('groups:frequency_annually_on_month_day', {
          month: moment(startDate).format('MMMM'),
          dayOrdinal: t('common:key', {
            count: startDate.getDate(),
            ordinal: true,
          }),
        });
      } else {
        return t('groups:frequency_annually_on_month_day_until', {
          month: moment(startDate).format('MMMM'),
          dayOrdinal: t('common:key', {
            count: startDate.getDate(),
            ordinal: true,
          }),
          stopDate: formattedStopDate,
        });
      }

    default:
      return null;
  }
};
